const drawerSectionId = document.querySelector('cart-drawer').dataset.id;

// Mobile Safari scroll lock management
class ScrollLockManager {
  constructor() {
    this.scrollPosition = 0;
    this.isLocked = false;
  }

  lock() {
    if (this.isLocked) return;
    
    // Store current scroll position
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Store sticky header state to restore later
    this.stickyHeader = document.querySelector('sticky-header');
    this.headerElement = document.querySelector('.section-header');
    this.wasHeaderSticky = this.headerElement && this.headerElement.classList.contains('shopify-section-header-sticky');
    this.bodyWasStickyEnabled = document.body.classList.contains('sticky-enable');
    
    // Temporarily disable sticky header to prevent conflicts
    if (this.headerElement) {
      this.headerElement.style.position = 'fixed';
      this.headerElement.style.top = '0';
      this.headerElement.style.left = '0';
      this.headerElement.style.right = '0';
      this.headerElement.style.zIndex = '999';
    }
    
    // Apply scroll lock with iOS Safari fixes
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');
    
    // Prevent iOS Safari bounce
    document.addEventListener('touchmove', this.preventScroll, { passive: false });
    
    this.isLocked = true;
  }

  unlock() {
    if (!this.isLocked) return;
    
    // Remove scroll lock styles
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');
    
    // Restore sticky header state
    if (this.headerElement) {
      this.headerElement.style.position = '';
      this.headerElement.style.top = '';
      this.headerElement.style.left = '';
      this.headerElement.style.right = '';
      this.headerElement.style.zIndex = '';
      
      // Restore sticky classes if they were active
      if (this.wasHeaderSticky) {
        this.headerElement.classList.add('shopify-section-header-sticky');
      }
      if (this.bodyWasStickyEnabled) {
        document.body.classList.add('sticky-enable');
      }
    }
    
    // Restore scroll position with a small delay to ensure DOM is ready
    setTimeout(() => {
      window.scrollTo(0, this.scrollPosition);
    }, 10);
    
    // Remove iOS Safari bounce prevention
    document.removeEventListener('touchmove', this.preventScroll);
    
    this.isLocked = false;
  }

  preventScroll(e) {
    // Allow scrolling within cart drawer
    if (e.target.closest('cart-drawer-items') || e.target.closest('.drawer__inner')) {
      return;
    }
    e.preventDefault();
  }
}

// Global scroll lock manager instance
const scrollLockManager = new ScrollLockManager();

// Safety reset on page load to clear any leftover scroll locks
document.addEventListener('DOMContentLoaded', function() {
  // Clear any leftover scroll lock styles
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  document.body.classList.remove('overflow-hidden');
  document.body.classList.remove('cart-drawer-open');
  scrollLockManager.isLocked = false;
  
  console.log('Cart drawer initialized and ready');
  
  // Clear any header style overrides
  const headerElement = document.querySelector('.section-header');
  if (headerElement) {
    headerElement.style.position = '';
    headerElement.style.top = '';
    headerElement.style.left = '';
    headerElement.style.right = '';
    headerElement.style.zIndex = '';
  }
  
  console.log('Cart event handlers set up successfully');
  
  // Also clear on window focus (for when users return from other tabs)
  window.addEventListener('focus', function() {
    if (!document.querySelector('cart-drawer.active')) {
      scrollLockManager.unlock();
    }
  });
  
  // Handle page navigation to ensure clean state
  window.addEventListener('beforeunload', function() {
    scrollLockManager.unlock();
  });
  
  // Safety check every 5 seconds to ensure scroll isn't stuck
  setInterval(function() {
    const cartDrawerActive = document.querySelector('cart-drawer.active');
    if (!cartDrawerActive && scrollLockManager.isLocked) {
      console.log('Cart drawer scroll lock safety reset triggered');
      scrollLockManager.unlock();
    }
  }, 5000);
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    // Remove href to prevent default cart page navigation
    cartLink.removeAttribute('href');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.style.cursor = 'pointer';
    
    // Store reference to this cart drawer instance
    const cartDrawerInstance = this;
    
    // Add our custom event listener directly (no cloning to avoid breaking references)
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      console.log('Cart icon clicked - opening drawer');
      cartDrawerInstance.open(cartLink);
    });
    
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
        event.preventDefault();
        event.stopPropagation();
        
        console.log('Cart icon keyboard activated - opening drawer');
        cartDrawerInstance.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log('Cart drawer open method called');
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Use the improved scroll lock manager
    scrollLockManager.lock();
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      console.log('Cart drawer classes added: animate, active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    console.log('Cart drawer close method called');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    
    // Use the improved scroll lock manager with delay to ensure smooth closing
    setTimeout(() => {
      scrollLockManager.unlock();
    }, 100);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: drawerSectionId,
        selector: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: drawerSectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('change', (event) => {
  const variantSelector = event.target.closest('.cart-drawer-best-sellers__variant');
  if (!variantSelector) return;

  const selectedOption = variantSelector.options[variantSelector.selectedIndex];
  const card = variantSelector.closest('.cart-drawer-best-sellers__card');
  const price = card?.querySelector('.cart-drawer-best-sellers__price');

  if (price && selectedOption?.dataset.price) {
    price.textContent = selectedOption.dataset.price;
  }
});

// Simplified global cart drawer controller
window.CartDrawerController = {
  open: function() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartIcon = document.querySelector('#cart-icon-bubble');
    
    if (cartDrawer && cartIcon) {
      console.log('Opening cart drawer via global controller');
      cartDrawer.open(cartIcon);
    } else {
      console.error('Cart drawer or cart icon not found');
    }
  }
};

// Global function to properly open cart drawer (used by custom cart add scripts)
window.openCartDrawer = function() {
  window.CartDrawerController.open();
};

// Global function to update cart drawer content safely
window.updateCartDrawer = function(responseText) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  const html = new DOMParser().parseFromString(responseText, 'text/html');
  
  // Update cart drawer
  cartDrawer.classList.remove('is-empty');
  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  const newDrawerInner = html.querySelector('cart-drawer .drawer__inner');
  if (drawerInner && newDrawerInner) {
    drawerInner.innerHTML = newDrawerInner.innerHTML;
  }
  
  // Update cart count bubble in header
  const currentCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  const newCartBubble = html.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (currentCartBubble && newCartBubble) {
    currentCartBubble.innerHTML = newCartBubble.innerHTML;
  }
  
  // Update all cart count elements
  const allCartCounts = document.querySelectorAll('.cart-count, [data-cart-count]');
  const newCartCounts = html.querySelectorAll('.cart-count, [data-cart-count]');
  allCartCounts.forEach((element, index) => {
    if (newCartCounts[index]) {
      element.textContent = newCartCounts[index].textContent;
    }
  });
};


document.addEventListener('click', function (e) {
  const button = e.target.closest('.cart-drawer-best-sellers__button');
  if (!button) return;

  e.preventDefault();

  const wrapper = button.closest('.cart-drawer-best-sellers__form');
  if (!wrapper) return;

  const variantField = wrapper.querySelector('.js-best-seller-variant');
  const selectField = wrapper.querySelector('select');

  const variantId = selectField
    ? selectField.value
    : variantField.value;

  if (!variantId || button.classList.contains('loading')) return;

  button.classList.add('loading');
  button.setAttribute('aria-disabled', 'true');

  const spinner = button.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: Number(variantId),
        quantity: 1
      }]
    }),
  })
    .then((r) => r.json())
    .then(() => fetch('/cart'))
    .then((r) => r.text())
    .then((html) => {
      window.updateCartDrawer(html);
      window.openCartDrawer();
    })
    .catch((err) => {
      console.error('Add to cart failed:', err);
    })
    .finally(() => {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    });
});